export const Config = {
    apiKey: "AIzaSyACi6WlclpGOPyc9JuHZ6V-8l8ZHRst2-w",
    frontApiUrl: 'https://cmsapi.fibrestream.ca/api/front',
    apiUrl: 'https://cmsapi.fibrestream.ca/api',
    beanfieldOrderPrefix: 'https://www.beanfield.com',
    addressSearchApiUrl: 'https://www.beanfield.com'
}



// WEBPACK FOOTER //
// ./src/data/config.js